var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"wask_loader bg_half_transparent test_red",attrs:{"fluid":"","pa-0":"","ma-0":"","fill-height":""}},[_c('v-row',{staticClass:"fill-height",attrs:{"justify":"center","align":"center"}},[_c('ring-loader',{attrs:{"color":_vm.$store.getters.appInfo.primary}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }